import { ReactComponent as Home } from "../../iconColor/home.svg";
import { ReactComponent as User } from "../../iconColor/user.svg";
import { ReactComponent as Cart } from "../../iconColor/cart.svg";
import { ReactComponent as Logout } from "../../iconColor/arrow-right-to-bracket-outline.svg";
import { ReactComponent as ChartPie } from "../../iconColor/chart-pie.svg";
import { ReactComponent as Wallet } from "../../iconColor/wallet.svg";

const title = `${
  !localStorage.getItem("old_access_token")
    ? "خروج از حساب"
    : "بازگشت به پنل ادمین"
}`;

export const DashboardsArray = [
  { name: "صفحه کاربری", url: "/fa/user-panel", icon: <Home /> },
  { name: "پروفایل", url: "/fa/user-panel/profile", icon: <User /> },
  {
    name: "اقساط",
    url: "/fa/user-panel/instalments",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="receipt">
          <path
            id="Vector"
            d="M18.383 2.07512C18.009 1.91812 17.58 2.00612 17.293 2.29212L16 3.58512L14.707 2.29212C14.316 1.90112 13.684 1.90112 13.293 2.29212L12 3.58512L10.707 2.29212C10.316 1.90112 9.684 1.90112 9.293 2.29212L8 3.58512L6.707 2.29212C6.421 2.00612 5.992 1.91912 5.617 2.07512C5.243 2.22912 5 2.59512 5 2.99913V20.9991C5 21.4031 5.243 21.7691 5.617 21.9231C5.991 22.0791 6.421 21.9931 6.707 21.7061L8 20.4131L9.293 21.7061C9.684 22.0971 10.316 22.0971 10.707 21.7061L12 20.4131L13.293 21.7061C13.684 22.0971 14.316 22.0971 14.707 21.7061L16 20.4131L17.293 21.7061C17.484 21.8971 17.74 21.9991 18 21.9991C18.129 21.9991 18.259 21.9751 18.383 21.9231C18.757 21.7691 19 21.4031 19 20.9991V2.99913C19 2.59512 18.757 2.22912 18.383 2.07512ZM15 16.9991H9C8.447 16.9991 8 16.5521 8 15.9991C8 15.4461 8.447 14.9991 9 14.9991H15C15.553 14.9991 16 15.4461 16 15.9991C16 16.5521 15.553 16.9991 15 16.9991ZM15 12.9991H9C8.447 12.9991 8 12.5521 8 11.9991C8 11.4461 8.447 10.9991 9 10.9991H15C15.553 10.9991 16 11.4461 16 11.9991C16 12.5521 15.553 12.9991 15 12.9991ZM15 8.99913H9C8.447 8.99913 8 8.55212 8 7.99913C8 7.44613 8.447 6.99913 9 6.99913H15C15.553 6.99913 16 7.44613 16 7.99913C16 8.55212 15.553 8.99913 15 8.99913Z"
          ></path>
        </g>
      </svg>
    ),
  },
  { name: "سفارشات", url: "/fa/user-panel/orders", icon: <Cart /> },
  {
    name: "سی کلاب",
    url: "/user-panel/30club",
    icon: <img src="/icons/coin.png" alt="" />,
  },
];

export const linksArray = [
  { name: "فروشگاه‌ها", url: "/shops" },
  { name: "درخواست اعتبار", url: "/fa/user-auth" },
  { name: "بلاگ‌ها", url: "/blogs" },
  { name: "درخواست همکاری", url: "/cooperation" },
];

export const DefaultArray = [
  // { name: "تنظیمات", url: "/dashboard/setting", icon: <Cog /> },
  // { name: "پشتیبانی و تیکت", url: "#", icon: <Headphones /> },
  // { name: "گفت‌وگو", url: "#", icon: <Messages /> },
  { name: title, url: "#", icon: <Logout /> },
];

export const StoreDashboardsArray = [
  { name: "داشبورد", url: "/fa/dashboard", icon: <ChartPie /> },
  { name: "پروفایل", url: "/fa/dashboard/profile", icon: <User /> },
  { name: "سفارشات", url: "/fa/dashboard/orders", icon: <Cart /> },
  { name: "قراردادها", url: "/fa/dashboard/contracts", icon: <ChartPie /> },
  { name: "تسویه‌ها", url: "/fa/dashboard/settlements", icon: <Wallet /> },
];
